import axios from 'axios'
import jwtDecode from 'jwt-decode'
import querystring from 'querystring'

import { parseUser } from './users'
// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE'

function TokenClass (tokenKeyName) {
  this.getToken = () => {
    const { token: queryToken } = querystring.parse(location.search.slice(1))
    this.error = null
    return queryToken || localStorage.getItem(tokenKeyName) || sessionStorage.getItem(tokenKeyName)
  }

  this.setToken = (token, enableRememberMe = false) => {
    if (enableRememberMe) {
      localStorage.setItem(tokenKeyName, token)
    } else {
      sessionStorage.setItem(tokenKeyName, token)
    }
  }
  this.clearToken = () => {
    localStorage.removeItem(tokenKeyName)
    sessionStorage.removeItem(tokenKeyName)
  }
  this.getCurrentUserFromToken = (token) => {
    try {
      return parseUser(jwtDecode(token))
    } catch (error) {
      this.clearToken()
      this.error = error
      console.log(error)
    }
  }
}

export function tokenManager (tokenKeyName) {
  return new TokenClass(tokenKeyName)
}

export function errorHandler (dispatch, error, type) {
  let errorMessage = ''

  if (error.data.error) {
    errorMessage = error.data.error
  } else if (error.data) {
    errorMessage = error.data
  } else {
    errorMessage = error
  }

  if (error.status === 401) {
    dispatch({
      type: type,
      payload: 'You are not authorized to do this. Please login and try again.'
    })
  } else {
    dispatch({
      type: type,
      payload: errorMessage
    })
  }
}

export function createStore ({
  ACTION_LOGIN_USER_REQUEST,
  ACTION_LOGIN_USER_SUCCESS,
  ACTION_LOGIN_USER_FAILURE,
  ACTION_LOGOUT_USER_REQUEST,
  ACTION_LOGOUT_USER_SUCCESS,
  ACTION_LOGOUT_USER_FAILURE,
  loginUrl = '/login',
  logoutUrl = '/logout',
  getToken,
  setToken,
  clearToken,
  getCurrentUserFromToken,
}) {
  // ------------------------------------
  // Actions
  // ------------------------------------

  function loginUser ({ username, password, enableRememberMe }) {
    return (dispatch) => {
      dispatch({ type: ACTION_LOGIN_USER_REQUEST })
      axios.post(loginUrl, { username, password })
        .then(response => {
          const {
            token,
            need_change_password
          } = response.data
          setToken(token, enableRememberMe)
          dispatch({
            type: ACTION_LOGIN_USER_SUCCESS,
            payload: {
              token,
              needChangePassword: need_change_password
            }
          })
        })
        .catch((error) => {
          clearToken()
          errorHandler(dispatch, error.response, ACTION_LOGIN_USER_FAILURE)
        })
    }
  }

  function logoutUser () {
    return function (dispatch) {
      dispatch({ type: ACTION_LOGOUT_USER_REQUEST })
      return axios.post(`${logoutUrl}`)
        .then(response => {
          dispatch({ type: ACTION_LOGOUT_USER_SUCCESS })
          clearToken()
        })
        .catch((error) => {
          console.log('logout error')
          console.log(error)
          dispatch({ type: ACTION_LOGOUT_USER_FAILURE })
          clearToken()
        })
    }
  }

  // ------------------------------------
  // Action Handlers
  // ------------------------------------

  const ACTION_HANDLERS = {
    [ACTION_LOGIN_USER_REQUEST]: (state, action) => ({
      ...state,
      currentUser: null,
      token: null,
      needChangePassword: false,
      errorMessage: '',
      isAuthenticating: true,
      isAuthenticated: false,
    }),
    [ACTION_LOGIN_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: getCurrentUserFromToken(action.payload.token),
      token: action.payload.token,
      needChangePassword: action.payload.needChangePassword,
      errorMessage: '',
      isAuthenticating: false,
      isAuthenticated: true,
    }),
    [ACTION_LOGIN_USER_FAILURE]: (state, action) => ({
      ...state,
      currentUser: null,
      token: null,
      needChangePassword: false,
      errorMessage: action.payload,
      isAuthenticating: false,
      isAuthenticated: false,
    }),
    [ACTION_LOGOUT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: null,
      token: null,
      isAuthenticated: false,
    }),
    [ACTION_LOGOUT_USER_FAILURE]: (state, action) => ({
      ...state,
      currentUser: null,
      token: null,
      isAuthenticated: false
    }),
  }

  // ------------------------------------
  // Reducer
  // ------------------------------------

  const initialState = (token => ({
    currentUser: token ? getCurrentUserFromToken(token) : null,
    token,
    needChangePassword: false,
    errorMessage: '',
    isAuthenticating: false,
    isAuthenticated: !!token,
  }))(getToken())

  function reducer (state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
  }

  return {
    actions: {
      loginUser,
      logoutUser,
    },
    reducer,
  }
}

const {
  getToken,
  setToken,
  clearToken,
  getCurrentUserFromToken,
} = tokenManager('authToken')

const {
  actions: {
    loginUser,
    logoutUser,
  },
  reducer,
} = createStore({
  ACTION_LOGIN_USER_REQUEST: LOGIN_USER_REQUEST,
  ACTION_LOGIN_USER_SUCCESS: LOGIN_USER_SUCCESS,
  ACTION_LOGIN_USER_FAILURE: LOGIN_USER_FAILURE,
  ACTION_LOGOUT_USER_REQUEST: LOGOUT_USER_REQUEST,
  ACTION_LOGOUT_USER_SUCCESS: LOGOUT_USER_SUCCESS,
  ACTION_LOGOUT_USER_FAILURE:  LOGOUT_USER_FAILURE,
  getToken,
  setToken,
  clearToken,
  getCurrentUserFromToken,
})

// ------------------------------------
// Actions
// ------------------------------------
export {
  loginUser,
  logoutUser,
}

// ------------------------------------
// Reducer
// ------------------------------------
export { reducer as default }

// initial axios
export function initAxios ({ dispatch }) {
  axios.interceptors.request.use(config => {
    config.headers.common['Authorization'] = config.headers.common['Authorization'] || `JWT ${getToken()}`
    return config
  }, error => Promise.reject(error))
  axios.interceptors.response.use(response => response, (error) => {
    if (error.response) {
      const {
        response: { status },
        skipErrorHandling
      } = error
      if (!skipErrorHandling && status === 401) {
        errorHandler(dispatch, error.response, LOGIN_USER_FAILURE)
      }
    }
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/store/auth.js